export default __webpack_public_path__ + "static/media/mapbox-marker-icon-blue.14573f11.svg";